module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reportPage",
    style: (_vm.pageCss)
  }, [(_vm.header && _vm.header.visible) ? _c('ReportHeader', {
    key: _vm.reportDef.id + '_header',
    attrs: {
      "orientation": _vm.orientation,
      "header": _vm.header
    }
  }) : _vm._e(), _vm._v(" "), (_vm.header && _vm.header.visible) ? _c('ReportLine', {
    style: (_vm.afterHeaderCss)
  }) : _vm._e(), _vm._v(" "), (_vm.body && _vm.body.visible) ? _c('ReportBody', {
    key: _vm.reportDef.id + '_body',
    attrs: {
      "orientation": _vm.orientation,
      "body": _vm.body,
      "pageHeader": _vm.pageHeader,
      "pageFooter": _vm.pageFooter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.body && _vm.body.visible) ? _c('ReportLine', {
    style: (_vm.afterBodyCss)
  }) : _vm._e(), _vm._v(" "), (_vm.footer && _vm.footer.visible) ? _c('ReportFooter', {
    key: _vm.reportDef.id + '_footer',
    attrs: {
      "orientation": _vm.orientation,
      "footer": _vm.footer
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-049b63e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportDesign/ReportPage.vue
// module id = 664
// module chunks = 0